// Module
var code = "<div class=loading-spinner><div id=spinner><div class=spinner></div></div><div ng-if=state.hasRouteChangeError><error-view></error-view></div><div ng-view=true style=display:none></div><sticky-footer></sticky-footer></div>";
// Exports
module.exports = code;